module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [(_vm.from === 'film') ? _c('div', {
    staticClass: "backgroundtexturefilm"
  }) : _c('div', {
    staticClass: "backgroundtexture"
  }), (_vm.container) ? _c('div', {
    staticClass: "info-show"
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 500,
        duration: 200
      }),
      expression: "{offset: 500, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fixed-bottom-right animate-pop",
    staticStyle: {
      "margin": "0 30px 30px 0"
    },
    attrs: {
      "round": "",
      "color": "negative"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-2x white"
  })]), _c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.container.titre))]), _vm._l((_vm.container.medias), function(med) {
    return _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', {
      staticClass: "conteneurimages"
    }, [_c('img', {
      staticClass: "mb1",
      attrs: {
        "src": med.image.thumbnail
      }
    }), _c('p', {
      domProps: {
        "innerHTML": _vm._s(med.image.description)
      }
    })]) : _vm._e()])
  }), _vm._l((_vm.container.medias), function(med) {
    return (_vm.from === true) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "height": "300px"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    }), _c('p', {
      staticClass: "mt2"
    }, [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e(), _c('div', {
      staticClass: "blocdescription",
      domProps: {
        "innerHTML": _vm._s(_vm.container.description)
      }
    })]) : _c('div', {
      staticClass: "blocdescription"
    }, [(_vm.container.medias[0].video && _vm.container.medias[0].video.titre === 'DoaJC Teaser') ? _c('div', _vm._l((_vm.container.medias), function(med) {
      return _c('div', {
        staticClass: "soustitre"
      }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.valvid)
        }
      })]) : _c('div', [_c('q-video', {
        staticStyle: {
          "height": "300px"
        },
        attrs: {
          "src": _vm.getVid(med.video.link)
        }
      }), _c('p', {
        staticClass: "mt2"
      }, [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()])
    })) : _vm._e(), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.container.description)
      }
    }, _vm._l((_vm.container.medias), function(med) {
      return _c('div', {
        staticClass: "soustitre"
      }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.valvid)
        }
      })]) : _c('div', [_c('q-video', {
        staticStyle: {
          "height": "300px"
        },
        attrs: {
          "src": _vm.getVid(med.video.link)
        }
      }), _c('p', {
        staticClass: "mt2"
      }, [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()])
    }))])
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06728584","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoShow.vue
// module id = 1273
// module chunks = 1